import { css } from "@emotion/react";
import { vars } from "@imwebme/clay-token";

export const cardSectionCSS = css({
  '[data-clay-card-inline="true"] &': {
    display: "flex",
    gap: vars.spacing[5],
  },

  '[data-clay-card-size="small"] &': {
    gap: 0,
  },
});
